import React, { useContext } from 'react';
import { FiCheckCircle } from 'react-icons/fi';

import { RSVPContext } from '../../context';
import StickyFooter from '../../../../components/StickyFooter';
import { FlexFlow } from '../../../../components/styles/Layout';

import {
  LPText,
  ContentWrapper,
  HighlightItem,
  HighlightItemContent,
  HighlightItemText,
} from '../../../styles';

const StepConfirmation = () => {
  const {
    contextData: {
      eventItemData,
      goToList,
    },
  } = useContext(RSVPContext);

  const {
    getVpn: {
      availableEvents,
    },
  } = eventItemData;

  const {
    representationalMetadataList,
    successMessage,
  } = availableEvents[0];

  const pageData = {
    instructions: '',
    btnLabel: '',
  };

  representationalMetadataList.forEach(({
    destination,
    content,
    type,
  }) => {
    if (destination === 'confirmation_page') {
      switch (type) {
        case 'BTN_LABEL':
          pageData.btnLabel = content;
          break;
        case 'INSTRUCTIONS':
          pageData.instructions = content;
          break;
        default:
          break;
      }
    }
  });

  return (
    <>
      <ContentWrapper>
        <LPText mb2>
          {pageData.instructions}
        </LPText>

        <FlexFlow column>
          <HighlightItem>
            <FiCheckCircle className="icon_start" />
            <HighlightItemContent>
              <HighlightItemText>
                {successMessage}
              </HighlightItemText>
            </HighlightItemContent>
          </HighlightItem>
        </FlexFlow>
      </ContentWrapper>

      <StickyFooter
        title={pageData.btnLabel}
        handleOnclick={goToList}
      />
    </>
  );
};

export default StepConfirmation;
